<template>
  <div class="flex flex-col justify-center sm:ml-0">
    <label class="inline-block font-medium mb-2">
      When do you want to go?
    </label>
    <div class="relative">
      <tooltip ref="tooltip" @hide="$emit('hide')" @show="$emit('show')">
        <template #trigger="{ show, hide, isShowing }">
          <div class="relative">
            <input
              class="search-input w-full cursor-pointer"
              :class="{ 'is-empty': dateDisplay }"
              placeholder="Anytime"
              readonly
              :value="dateDisplay"
              @focus="show"
              @keydown.tab="hide"
              tabindex="2001"
            />

            <svg
              width="24"
              height="24"
              class="search-icon text-black-light-5"
              fill="#222222"
            >
              <use xlink:href="/img/sprite.svg#ic_calendar"></use>
            </svg>

            <svg
              width="24"
              height="24"
              style="right: 10px; top: 25%"
              class="flex-none pointer-events-none absolute"
              :class="{ 'transform rotate-180 fill-secondary': isShowing }"
            >
              <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
            </svg>
          </div>
        </template>

        <template #default="{ hide }">
          <div class="drop-panel single-picker">
            <month-picker
              :dates="datetime"
              @input="handleMonthSelected"
              @close="hide"
            />
          </div>
        </template>
      </tooltip>

      <div class="absolute cursor-pointer clear-icon" @click="handleClearTime">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_close"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "../core/Tooltip";
import MonthPicker from "../core/MonthPicker";

export default {
  components: {
    MonthPicker,
    Tooltip,
  },
  props: ["datetime"],
  computed: {
    dateDisplay() {
      if (this.datetime[0]) {
        return this.datetime[0].format("MMM YYYY");
      }
      return null;
    },
  },
  methods: {
    handleMonthSelected(from) {
      this.$emit("set-datetime", from);
      this.$refs.tooltip.hide();
    },
    handleClearTime() {
      this.$emit("set-datetime", [null]);
    },
  },
};
</script>

<style scoped>
::v-deep .search-input {
  border-radius: 0.5rem;
  border: 1px solid #000;
}

::v-deep ::placeholder {
  color: #5e5f5f !important;
  opacity: 1;
}

.clear-icon {
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
